<template>
  <div id="afdc-ev-terms" :class="{'afdc-modal-box':true, 'afdc-mobile-ev-terms-view': isMobileView}" v-show="modalOpen" v-on-clickaway="closeEvTerms">
    <div class="afdc-modal-closer" v-on:click="closeEvTerms"><span class="afdc-sr-only">{{ $t('Close') }}</span><font-awesome-icon icon="times-circle" class="afdc-fa-icon"/></div>

    <h2>{{ $t('Charging Infrastructure Terminology') }}</h2>

    <p>{{ $t('The Alternative Fueling Station Locator uses the following charging infrastructure definitions:') }}</p>

    <ul>
      <li><strong>{{ $t('Station Location') }}:</strong> {{ $t('A station location is a site with one or more EV charging ports at the same address. Examples include a parking garage or a mall parking lot.') }}</li>

      <li><strong>{{ $t('EV Charging Port') }}:</strong> {{ $t('An EV charging port provides power to charge only one vehicle at a time even though it may have multiple connectors. The unit that houses EV charging ports is sometimes called a charging post, which can have one or more EV charging ports. EV charging ports are also sometimes referred to as electric vehicle supply equipment (EVSE) ports.') }}</li>

      <li><strong>{{ $t('Connector') }}:</strong> {{ $t('A connector is what is plugged into a vehicle to charge it. Multiple connectors and connector types (such as CHAdeMO and CCS) can be available on one EV charging port, but only one vehicle will charge at a time. Connectors are sometimes called plugs.') }}</li>
    </ul>

    <img v-bind:src="require(`@/assets/images/charging-infrastructure-terms-${ $store.getters.localeLang }.jpg`)" class="afdc-ev-terms-diagram" v-bind:alt="$t('Diagram of an electric vehicle charging station showing how one station can have multiple EVSE ports and each EVSE port can have one or more connectors')">
  </div>
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway';

export default {
  name: 'EvTerms',

  mixins: [
    clickaway,
  ],

  computed: {
    modalOpen() {
      return this.$store.getters.getEvTermsModalOpen;
    },
    isMobileView() {
      return this.$store.getters.isMobileView;
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$store.getters.isMobileView) {
        document.querySelector('#afdc-ev-terms').style.height = `${window.innerHeight - 110}px`;
      }
    });
  },

  methods: {
    closeEvTerms() {
      if (this.$store.getters.getEvTermsModalLinkClicked) {
        this.$store.commit('setEvTermsModalLinkClicked', false);
      } else {
        if (this.$route.query.show_ev_terms) {
          this.$router.push({ query: { ...this.$route.query, show_ev_terms: undefined } });
        }
        this.$store.commit('setEvTermsModalOpen', false);
      }
    },
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';

#ev-terms {
  width: 75%;
  max-width: 1000px;
  max-height: 700px;

  .modal-closer {
    margin-left: calc(75% - 55px);
  }

  @media (min-width: 1335px) {
    .modal-closer {
      margin-left: calc(1000px - 55px);
    }
  }

  ul {
    margin-left: 40px;
    li {
      margin-bottom: 16px;
    }
  }

  img.ev-terms-diagram {
    width: 100%;
    max-width: 700px;
    display: block;
    margin: 20px auto 0 auto;
  }
}

.mobile-ev-terms-view {
  width: 95% !important;
  max-height: 1000px !important;
  margin-top: 55px !important;

  .modal-closer {
    margin-left: calc(95% - 55px)!important;
  }
}
</style>
